import React from 'react';
import Typography from "@mui/material/Typography";
import {Trans} from "react-i18next";
import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import {Delete} from "@mui/icons-material";

function AdminTextParam({param, onChange, onDelete}) {
    const setMaxlength = (value) => {
        param.props = param.props || {};
        param.props.maxLength = Number(value);
        onChange(param);
    }

    return (
        <div>
            <Typography fontWeight={500} sx={{pb: 2}}>
                {param.key}
                <IconButton onClick={onDelete}><Delete/></IconButton>
            </Typography>
            <Typography>
                <Trans i18nKey={`params.${param.key}`}/>
            </Typography>
            <Typography variant={'body2'}>
                Can change on translation (params.{param.key})
            </Typography>
            <TextField size={'small'} type={'number'} value={param.values?.maxLength}
                       onChange={event => setMaxlength(event.target.value)}/>
        </div>
    );
}

export default AdminTextParam;
